import "./EcoSectionthree.css";
// import Ellipse from "../EcoSysImages/Ellipse.png";
import Star from "../EcoSysImages/star.png";
// import WheelGif from "../EcoSysImages/Wheel_gif.gif";
// import VoxyGif from "../EcoSysImages/voxy_gif.gif";
import { HashLink as Link } from "react-router-hash-link";
import Lottie from "lottie-react";
import wheelAnimation from "../EcoSysImages/wheel.json";
import voxtAnimation from "../EcoSysImages/voxy.json";
export default function EcoSectionThree() {
  return (
    <section
      className="section-three-bg"
      style={{ position: "relative", overflow: "hidden" }}
    >
      <div className="section-three-container">
        <div className="wheel-container">
          <Wheel />
          {/* <img src={WheelGif} alt="Spinning Wheel" className="wheel-icon" /> */}
          {/* <img src={Ellipse} alt="fog" className="ellipse-icon" /> */}
          <Voxy />
          {/* <img src={VoxyGif} alt="Voxy Mascot" className="voxy-icon" /> */}
        </div>
        <div className="section-three-content">
          <div className="step-indicator">
            <span className="step-current">03</span>
            <span className="step-total">/05</span>
          </div>
          <h1 className="section-title">Meet Quests</h1>
          <ul className="quest-list">
            <li>
              <img src={Star} alt="star" className="star-icon" />
              Keep your streak to multiply your rewards.
            </li>
            <li>
              <img src={Star} alt="star" className="star-icon" />
              Daily and themed quests—from posting to collabs.
            </li>
            <li>
              <img src={Star} alt="star" className="star-icon" />
              Earn XP, badges, visibility boosts, and exclusive AI styles.
            </li>
          </ul>
          {/* <button className="get-start-button">Get Started</button> */}
          <div className="eco-three-section-button">
            <Link to="/#get3voApp" onClick={() => window.scrollTo(0, 0)}>
              <div className="create-token-btn-eco">
                <p className="create-token-btn-text">Get Started</p>
              </div>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
export function Wheel() {
  return (
    <div className="w-64 h-64">
      <Lottie animationData={wheelAnimation} loop={true} autoplay={true} />
    </div>
  );
}

export function Voxy() {
  return (
    <div className="w-64 h-64 voxy-icon">
      <Lottie animationData={voxtAnimation} loop={true} autoplay={true} />
    </div>
  );
}
